import "../CSSFiles/Description.css"
import down_arrow from "../Images/down_arrow.png"
import {useRef} from "react"


export const ServiceDescription = (props) => {

    const additional_info_ref = useRef(null)
    const service_description_ref = useRef(null)

    const disable_additional_text = () => {        
        if (additional_info_ref.current.classList.contains("disp-none-services")) {
            additional_info_ref.current.classList.remove("disp-none-services")
            service_description_ref.current.classList.remove("service-description-less")
            service_description_ref.current.classList.add("service-description-expanded")
        }
        else {
            additional_info_ref.current.classList.add("disp-none-services")
            service_description_ref.current.classList.add("service-description-less")
            service_description_ref.current.classList.remove("service-description-expanded")
        }
    }



    return <div className="service-description service-description-less" ref={service_description_ref}  onClick={disable_additional_text}>

        <div className="top-section">
            <h2> {props.ServiceName}</h2>
            <img src={down_arrow} alt="Expand information"/>
        </div>
        <p ref={additional_info_ref}className="additional-service-info disp-none-services"> {props.ServiceText}</p>
    </div>
}